/** The app's mark: an A on a light tile, with the accent notch in its corner (styles/sidebar.css). */
export function BrandMark(): React.JSX.Element {
  return (
    <span className="brand-mark" aria-hidden="true">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 13 8 3l5 10" strokeWidth="2.2" />
        <path d="M5.7 9.4h4.6" strokeWidth="2" />
      </svg>
    </span>
  );
}
